import { createFileRoute, Navigate } from '@tanstack/react-router';

export const Route = createFileRoute('/design-system/')({
  component: () => <Navigate to="/design-system/button" />,
});
